import { instanceCoveryt, instanceFalyt } from './axiosConfig'

const CroppingTypeNextlanePlatForm = {
  CROPPING: '/ai/v1/vehicle/crop',
  PARTIAL_CROPPING: '/ai/v1/processes/crop-partial',
  FADED_CROPPING: '/ai/v1/vehicle/crop-fading'
}

export default {
  async croppedImage(data, type) {
    try {
      return await instanceFalyt.post(CroppingTypeNextlanePlatForm[type], data)
    } catch (err) {
      return null
    }
  },
  // Call account api to find user details
  async getLicensePlateCoverForImage(data) {
    const url = `/ai/v1/vehicle/plate-coordinates`
    return await instanceCoveryt.post(url, data)
  }
}
